import React from "react";
import Skeleton from "@mui/material/Skeleton";
import { Handle, HandleType, Position } from "@xyflow/react";

import { isActiveSplice, SpliceRecord, SpliceRecordCable } from "fond/topologicalView/types";

interface IProps {
  dimensions: { width: number; height: number };
  spliceRecords: SpliceRecord[];
}

const getHandleId = (cable: SpliceRecordCable): string | null => (isActiveSplice(cable) ? cable.handleId : null);

const SpliceRangeNodeSkeleton: React.FC<IProps> = ({ dimensions, spliceRecords }) => {
  const handles = spliceRecords.flatMap(({ input, output }) => [
    { type: "target" as HandleType, position: Position.Left, id: getHandleId(input) },
    { type: "source" as HandleType, position: Position.Right, id: getHandleId(output) },
  ]);

  return (
    <>
      <Skeleton variant="rectangular" data-testid="splice-node-skeleton" {...dimensions} />
      {handles
        .filter(({ id }) => id !== null)
        .map(({ type, position, id }) => (
          <Handle key={id} type={type} position={position} id={id!} />
        ))}
    </>
  );
};

export default SpliceRangeNodeSkeleton;
